import { NgModule } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';

@NgModule({
  imports: [MatDialogModule]
})
export class DialogModule {}
